import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'bestellen aan tafel',
    [ORDER_METHODS.PICKUP]: 'afhalen',
    [ORDER_METHODS.DELIVERY]: 'bezorging',
  },
  errors: {
    draft_validation_failed: 'Vul je bezorgadres in voordat je doorgaat.',
  },
};
